import { validatePresence, validateLength, validateFormat } from 'ember-changeset-validations/validators'

export default {
  plainPassword: [validatePresence(true), validateLength({ min: 4 }), validateFormat({ regex: /\s/g, inverse: true })],
}
